module.exports = __webpack_public_path__ + "static/media/TUS.8be59457.png";